import PropTypes from 'prop-types';
import React from 'react';
import styles from '../EcsPortal.module.scss';
import { handleImpressionsTrack, sendOtp } from '../../../api';
import { useAuth } from '../../../contexts/auth';
import { handleResendTimer } from '../../../reducersAndActions/actions/authAction';
import { clickTracker } from '../../../lib/common';

export default function DisClaimer({
  status,
  setCurrentComponent,
  currentComponent,
  getCreateTicket,
  setIsButtonClicked,
  isButtonClicked,
  projectId,
  faqObj,
}) {
  const [authState, authDispatch] = useAuth();
  const labels = {
    csportal: {
      stop: 'Stopping ECS means you miss out on some great benefits!',
      cancel: 'Cancelling ECS mandate means you miss out on some great benefits!',
      reactivate: 'Your request to reactivate ECS has been received and your services are reactivated.',
    },
    genio: {
      stop: 'Stopping ECS means you miss out on some great benefits!',
      cancel: 'Cancelling ECS mandate means you miss out on some great benefits!',
      reactivate:
        'Your request for reactivation of ECS is registered with us! We will get in touch with client shortly.',
    },
  };

  const handleContinueBtnClick = async () => {
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_continue`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_ecs`;
      const llTrdInside = `faq_${faqObj?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);

      const res = await sendOtp();
      handleResendTimer(authDispatch, {
        ...authState,
        resendOtp: true,
      });
      if (res) setCurrentComponent(currentComponent + 1);
    }
    await clickTracker(`FAQ_${status.toLowerCase()}_continue`, `ecs_FAQ_${status.toLowerCase()}`);
  };
  return (
    <div>
      <>
        <div className="font12 fw600 color111 mb-12">{labels[projectId][status.toLowerCase()]}</div>

        {status.toLowerCase() === 'reactivate' && projectId === 'csportal' && (
          <div className="font12 fw600 color777 mb-10">{`Here's how Justdial services help you!`}</div>
        )}
        {((status.toLowerCase() === 'reactivate' && projectId === 'csportal') ||
          status.toLowerCase() !== 'reactivate') && (
          <>
            <ul className={`${styles.Accordion__DotItems} `}>
              <li className={`${styles.Accordion__DotItem}`}>
                <span className={`${styles.Accordion__DotItem__Circle} mr-10`} />
                <span className={`${styles.Accordion__DotItem__Text} font12 fw400 color111`}>
                  Visibility to over 25 crore ready to buy customers using Justdial
                </span>
              </li>
              <li className={`${styles.Accordion__DotItem}`}>
                <span className={`${styles.Accordion__DotItem__Circle} mr-10`} />
                <span className={`${styles.Accordion__DotItem__Text} font12 fw400 color111`}>
                  24/7 Digital presence of your business on search engines
                </span>
              </li>
              <li className={`${styles.Accordion__DotItem}`}>
                <span className={`${styles.Accordion__DotItem__Circle} mr-10`} />
                <span className={`${styles.Accordion__DotItem__Text} font12 fw400 color111`}>
                  10x* more visibility than a company that is not paying Justdial
                </span>
              </li>
              <li className={`${styles.Accordion__DotItem}`}>
                <span className={`${styles.Accordion__DotItem__Circle} mr-10`} />
                <span className={`${styles.Accordion__DotItem__Text} font12 fw400 color111`}>
                  Justdial Verified Stamp and reviews & ratings to help you earn the trust of customers
                </span>
              </li>
              <li className={`${styles.Accordion__DotItem}`}>
                <span className={`${styles.Accordion__DotItem__Circle} mr-10`} />
                <span className={`${styles.Accordion__DotItem__Text} font12 fw400 color111`}>
                  {`Your absence is your competitor's gain`}
                </span>
              </li>
            </ul>

            <div className="font10 fw400 color777 mt-15">*Varies from category to category</div>
          </>
        )}
      </>
      {status.toLowerCase() !== 'reactivate' && (
        <div className={`${styles.Accordion__Contant__Btnbox}`}>
          {(status.toLowerCase() !== 'cancel' || (status.toLowerCase() === 'cancel' && projectId === 'genio')) && (
            <button
              type="button"
              className={`${styles.Accordion__Contant__Button} blue_whitefill_animate font14 fw600 color007 mt-20`}
              style={{
                border: '1px solid #0076D7',
                backgroundColor: projectId === 'csportal' ? '#E5F1FB' : '#0076d7',
                color: projectId === 'genio' ? '#fff' : '',
              }}
              disabled={isButtonClicked}
              onClick={async () => {
                setIsButtonClicked(true);
                getCreateTicket({ type: projectId === 'csportal' ? 'callback' : status.toLowerCase() });
                const genioCancelEcsMandateFaq = projectId === 'genio' && status === 'cancel';
                await clickTracker(
                  `FAQ_${genioCancelEcsMandateFaq ? 'cancelecs' : status.toLowerCase()}_${
                    projectId === 'csportal' ? 'callback' : 'proceed'
                  }`,
                  `ecs_FAQ_${status.toLowerCase()}`,
                );
                if (projectId === 'csportal') {
                  const liVal = 'click';
                  const liTrd = `cta_getcallback`;
                  const faqTypeVal = '';
                  const othersData = [];
                  const llTrd = `issue_ecs`;
                  const llTrdInside = `faq_${faqObj?.faqKey}`;
                  await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
                }
              }}
            >
              {projectId === 'csportal' ? 'Get a Call Back' : 'Proceed'}
            </button>
          )}
          {projectId === 'csportal' && (
            <button
              type="button"
              className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-20`}
              style={{
                backgroundColor: '#0076d7',
                border: '1px solid #0076d7',
                transitionProperty: 'background-color, background-image, border-color, box-shadow',
                transition: 'all 0.8s',
                color: '#fff',
              }}
              onClick={() => handleContinueBtnClick()}
            >
              Continue
            </button>
          )}
        </div>
      )}
    </div>
  );
}

DisClaimer.propTypes = {
  status: PropTypes.string,
  setCurrentComponent: PropTypes.func,
  currentComponent: PropTypes.number,
  getCreateTicket: PropTypes.func,
  setIsButtonClicked: PropTypes.func,
  isButtonClicked: PropTypes.bool,
  projectId: PropTypes.string,
  faqObj: PropTypes.object,
};
